import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NzMessageService } from 'ng-zorro-antd/message';

export const IGNORE_AUTH_INTERCEPTOR_HEADER =
  'X-Ignore-Permnission-Interceptor';

@Injectable()
export class PermissionInterceptor implements HttpInterceptor {
  private readonly messageService = inject(NzMessageService);
  private readonly translate = inject(TranslateService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (req.headers.get(IGNORE_AUTH_INTERCEPTOR_HEADER)) {
      return next.handle(req);
    } else {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status !== 403 || req.url.includes('/files')) {
            return throwError(() => error);
          } else {
            this.messageService.error(
              this.translate.instant('error.forbidden'),
            );
            return throwError(() => error);
          }
        }),
      );
    }
  }
}
